import React from "react";
import { useLang } from "../i18n";
import { RestTimer } from "./RestTimer";
import { exerciseImage } from "../constants/brand";
import { Dumbbell, Flame, Clock } from "lucide-react";

export function WorkoutCard({ workout, color = "#3F6E85" }) {
  const { t } = useLang();
  if (!workout) return null;
  const warmup = Array.isArray(workout.warmup) ? workout.warmup : [];
  const exercises = Array.isArray(workout.exercises) ? workout.exercises : [];

  return (
    <div className="mt-3 rounded-2xl border border-[#3F6E85]/15 bg-[#F4F6FA] overflow-hidden" data-testid="workout-card">
      <div className="flex items-center justify-between px-5 py-3 bg-[#3F6E85] text-white">
        <span className="inline-flex items-center gap-2 text-sm font-semibold">
          <Dumbbell className="w-4 h-4" /> {t("workout_card")}
        </span>
        {workout.duration_min ? (
          <span className="inline-flex items-center gap-1 text-xs text-white/80">
            <Clock className="w-3.5 h-3.5" /> {workout.duration_min} min
          </span>
        ) : null}
      </div>

      <div className="p-5 space-y-5">
        {warmup.length > 0 && (
          <div>
            <p className="inline-flex items-center gap-1.5 text-xs uppercase tracking-wider text-[#B5651D] font-semibold mb-3">
              <Flame className="w-3.5 h-3.5" /> {t("workout_warmup")}
            </p>
            <div className="space-y-2">
              {warmup.map((w, i) => (
                <div key={i} data-testid={`warmup-${i}`} className="flex items-center gap-3 rounded-xl bg-white border border-stone-200 px-4 py-3">
                  <span className="w-9 h-9 rounded-xl bg-[#FBEEDF] flex items-center justify-center shrink-0">
                    <Flame className="w-4 h-4 text-[#B5651D]" />
                  </span>
                  <span className="text-sm font-medium text-[#2B4A59]">{w}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {exercises.length > 0 && (
          <div className="space-y-3">
            {exercises.map((ex, i) => (
              <div key={i} data-testid={`workout-exercise-${i}`}
                className="flex items-center gap-4 rounded-2xl bg-white border border-stone-200 p-4 hover:border-[#3F6E85]/30 transition-colors">
                <span className="w-16 h-16 rounded-2xl overflow-hidden bg-white border border-stone-200 flex items-center justify-center shrink-0">
                  <img src={exerciseImage(ex.name)} alt={ex.name} className="w-full h-full object-contain" loading="lazy" />
                </span>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold text-[#2B4A59] text-[15px] leading-tight">{ex.name}</p>
                  {ex.note && <p className="text-xs text-[#6E6B65] mt-1">{ex.note}</p>}
                  <div className="flex flex-wrap items-center gap-x-5 gap-y-1 mt-2">
                    <span className="text-sm"><span className="text-[11px] uppercase tracking-wider text-[#6E6B65]">{t("workout_series")} </span><b className="text-[#3F6E85]">{ex.sets ?? "—"}</b></span>
                    <span className="text-sm"><span className="text-[11px] uppercase tracking-wider text-[#6E6B65]">{t("workout_reps")} </span><b className="text-[#3F6E85]">{ex.reps ?? "—"}</b></span>
                    <span className="inline-flex items-center gap-1.5">
                      <span className="text-[11px] uppercase tracking-wider text-[#6E6B65]">{t("workout_rest")}</span>
                      <RestTimer rest={ex.rest} color={color} />
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

